/* Shopify path: assets/beulah-wishlist.js
 * Simple client-side wishlist (no app needed) — stores product info in
 * localStorage so it survives reloads on this browser/device.
 * Powers: header bookmark icon + count badge, PDP "Add to wishlist" button,
 * product-card quick-toggle icon, and the /pages/wishlist listing page.
 */
(function (window, document) {
  var STORAGE_KEY = 'bsWishlist';

  function getWishlist() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  }

  function saveWishlist(list) {
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function isInWishlist(handle) {
    return getWishlist().some(function (item) { return item.handle === handle; });
  }

  function addToWishlist(item) {
    var list = getWishlist();
    if (!list.some(function (i) { return i.handle === item.handle; })) {
      list.push(item);
      saveWishlist(list);
    }
    refreshUI();
  }

  function removeFromWishlist(handle) {
    saveWishlist(getWishlist().filter(function (i) { return i.handle !== handle; }));
    refreshUI();
  }

  function updateCountBadges() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function updateToggleButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      var active = isInWishlist(handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (!btn.querySelector('svg')) {
        var onLabel = btn.getAttribute('data-label-on') || 'Remove from wishlist';
        var offLabel = btn.getAttribute('data-label-off') || 'Add to wishlist';
        btn.textContent = active ? onLabel : offLabel;
      }
    });
  }

  function renderWishlistGrid() {
    var grid = document.getElementById('bsWishlistGrid');
    if (!grid) return;
    var empty = document.getElementById('bsWishlistEmpty');
    var list = getWishlist();
    grid.innerHTML = '';
    if (!list.length) {
      if (empty) empty.style.display = '';
      return;
    }
    if (empty) empty.style.display = 'none';
    list.forEach(function (item) {
      var card = document.createElement('div');
      card.className = 'bs-card';
      card.innerHTML =
        '<a href="' + item.url + '" class="bs-card-img" style="aspect-ratio:3/4;display:block">' +
          '<img src="' + item.image + '" alt="" loading="lazy" style="width:100%;height:100%;object-fit:cover;position:absolute;inset:0">' +
        '</a>' +
        '<div class="bs-card-info">' +
          '<a href="' + item.url + '" class="name" style="color:inherit">' + item.title + '</a>' +
          '<span class="price">' + item.price + '</span>' +
        '</div>' +
        '<button type="button" class="bs-link-underline" data-wishlist-remove="' + item.handle + '" style="align-self:flex-start;margin-top:2px;background:none;border:none;cursor:pointer;padding:0">Remove</button>';
      grid.appendChild(card);
    });
    grid.querySelectorAll('[data-wishlist-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        removeFromWishlist(btn.getAttribute('data-wishlist-remove'));
      });
    });
  }

  function refreshUI() {
    updateCountBadges();
    updateToggleButtons();
    renderWishlistGrid();
  }

  function bindToggles() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      if (btn.dataset.wishlistBound) return;
      btn.dataset.wishlistBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var handle = btn.getAttribute('data-handle');
        if (isInWishlist(handle)) {
          removeFromWishlist(handle);
        } else {
          addToWishlist({
            handle: handle,
            id: btn.getAttribute('data-id'),
            title: btn.getAttribute('data-title'),
            price: btn.getAttribute('data-price'),
            image: btn.getAttribute('data-image'),
            url: btn.getAttribute('data-url')
          });
        }
      });
    });
  }

  function init() {
    bindToggles();
    refreshUI();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.BeulahWishlist = { add: addToWishlist, remove: removeFromWishlist, list: getWishlist, isInWishlist: isInWishlist };
})(window, document);
